import * as React from 'react'
import * as Lodash from 'lodash'

export const twoLineText = (text: any) => {
  return (
    <>
      <span>{text.substring(0, 20)}</span> <br />
      <span>{text.substring(20, text.length)}</span>
    </>
  )
}

export const removeLastElementFromPathString = (field: string): string => {
  if (!field) {
    return field
  }

  const newField = field.split('.').slice(0, -1).join('.')

  return newField
}

export const removeFirstElementFromPathString = (field: string): string => {
  const split = field.split('.')
  if (split.length > 1) {
    const [, ...tail] = split

    return tail.join('.')
  }

  return field
}

const SPECIAL_CHARACTER_RANGES: Array<[number, number]> = [
  [0x00, 0x08], // C0 control characters (BEL, BS, ...)
  [0x0b, 0x0c], // vertical tab, form feed
  [0x0e, 0x1f], // C0 control characters (ESC, ...)
  [0x7f, 0x9f], // DEL + C1 control characters
  [0xad, 0xad], // soft hyphen
  [0x034f, 0x034f], // combining grapheme joiner
  [0x061c, 0x061c], // arabic letter mark (bidi)
  [0x180e, 0x180e], // mongolian vowel separator
  [0x200b, 0x200f], // zero-width space/joiners + LRM/RLM
  [0x2028, 0x2029], // line / paragraph separators
  [0x202a, 0x202e], // bidi embeddings & overrides (LRE/RLE/PDF/LRO/RLO)
  [0x2060, 0x2064], // word joiner + invisible math operators
  [0x2066, 0x2069], // bidi isolates (LRI/RLI/FSI/PDI)
  [0xfeff, 0xfeff], // zero-width no-break space / byte-order-mark
  [0xfff9, 0xfffb], // interlinear annotation anchors
  [0xfffc, 0xfffc], // object replacement character
  [0xfffd, 0xfffd], // replacement character (the literal "tofu")
]

const SPECIAL_CHARACTERS_REGEX = new RegExp(
  '[' +
    SPECIAL_CHARACTER_RANGES.map(([from, to]) =>
      from === to
        ? String.fromCharCode(from)
        : `${String.fromCharCode(from)}-${String.fromCharCode(to)}`,
    ).join('') +
    ']',
  'g',
)

const EMOJI_REGEX = new RegExp(
  '\\p{Extended_Pictographic}|\\p{Emoji_Presentation}|\\p{Emoji_Modifier}|\\p{Regional_Indicator}|[\\u{20E3}\\u{FE00}-\\u{FE0F}]',
  'gu',
)

export const stripSpecialCharacters = (value: string): string => {
  if (!value) {
    return value
  }

  return value.replace(SPECIAL_CHARACTERS_REGEX, '').replace(EMOJI_REGEX, '')
}

export const nicer = (str: string) => Lodash.startCase(Lodash.camelCase(str))

export const elipsedText = (maxLen: number, text: string) => {
  if (!text) {
    return text
  }

  if (text.length < maxLen) {
    return text
  }

  if (text.length < maxLen + 3) {
    return text
  }

  return text.substring(0, maxLen) + '...'
}

export const padNumbersInString = (
  str: string,
  padLength: number,
  padChar: string = '0',
) => {
  const regex = /\[([0-9]+)\]/g
  return str.replace(regex, (match) => {
    return Lodash.padStart(match, padLength, padChar)
  })
}
